import { apiClient } from './api'

export interface BrandIdentity {
  shopId: string
  shopCode: string
  shopName: string
  logoUrl?: string | null
  bannerUrl?: string | null
  faviconUrl?: string | null
  themeColor?: string | null
  secondaryColor?: string | null
  fontFamily?: string | null
  taglineText?: string | null
  heroTagline?: string | null
  isWhiteLabel: boolean
}

export const brandService = {
  /**
   * Resolve the current hostname to a shop brand.
   *
   * Distinguishes two failure modes — critical for router 404 semantics:
   *   - **404 from backend** → returns `null`. The host is deterministically
   *     not registered to any shop. Caller can safely redirect to /404.
   *   - **Anything else** (network error, 5xx, timeout, CORS) → throws. Caller
   *     must NOT interpret this as "unknown domain" — a transient network
   *     hiccup used to nuke every WL URL into a Google-indexed 404. The
   *     brand store treats this as retryable.
   *
   * Was previously catching-all → null, which meant a single API blip on the
   * SPA's first paint would collapse the entire WL site into /404 in Google's
   * eyes. See router/index.ts beforeEach for the consumer side.
   */
  async getBrandForHost(hostname: string): Promise<BrandIdentity | null> {
    try {
      return await apiClient.get<BrandIdentity>('/shop/custom-domain/brand', {
        params: { hostname },
      })
    } catch (err: any) {
      if (err?.response?.status === 404) return null
      throw err
    }
  },
}
